import ACTION_TYPE from '../../store/ACTION_TYPE';
import createReducerFunction from '../../store/reducerCreator';

interface State {
    active: boolean;
    isFetching: boolean;
    suggestionSubmitted: boolean;
}

const initialState = {
    active: false,
    isFetching: false,
    suggestionSubmitted: false,
};

const reducers = {
    [ACTION_TYPE.OPEN_SUGGESTION]: (state: State) => ({ ...state, active: true }),
    [ACTION_TYPE.CLOSE_SUGGESTION]: () => initialState,
    [ACTION_TYPE.SUGGEST_APP_PENDING]: (state: State) => ({ ...state, isFetching: true }),
    [ACTION_TYPE.SUGGEST_APP_FULFILLED]: (state: State) => ({ ...state, isFetching: false, suggestionSubmitted: true }),
    [ACTION_TYPE.SUGGEST_APP_REJECTED]: (state: State) => ({ ...state, isFetching: false }),
};

interface Action {
    type:
        | ACTION_TYPE.OPEN_SUGGESTION
        | ACTION_TYPE.CLOSE_SUGGESTION
        | ACTION_TYPE.SUGGEST_APP_PENDING
        | ACTION_TYPE.SUGGEST_APP_FULFILLED
        | ACTION_TYPE.SUGGEST_APP_REJECTED;
}

export default createReducerFunction<State, Action>({
    initialState,
    reducers,
});
